<subs-select [controlName]="controlName" [label]="label">
  <option value=""></option>
  <option *ngFor="let name of this.claimingGAList" [value]="name"
    >{{ name }}</option
  >
</subs-select>
